import { Link } from "@inertiajs/react";
import ItemCard from "../shared/ItemCard";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faScroll } from "@fortawesome/free-solid-svg-icons";

export default function ReferencesSectionCard({
  referencesSection
}: any) {
  const hasReferencesImages = referencesSection.references.some((ref: any) => ref.image_url);
  return (
    <>
      <ItemCard
        href={`/references/${referencesSection.id}`}
        className="ref-section-card"
      >
        {hasReferencesImages ? (
          <div
            className="ref-card-image ref-card-image-grid"
            style={{
              backgroundColor: 'var(--color-base-300)',
              overflow: 'hidden',
            }}
          >
            {referencesSection.references.map((reference: any, index: number) => (
              <div key={index} style={{
                aspectRatio: '1 / 1',
              }}>
                <div style={{
                  aspectRatio: '1 / 1',
                  backgroundImage: `url(${reference.image_url})`,
                  backgroundSize: 'cover',
                  backgroundPosition: 'center',
                }}>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div
            className="ref-card-image"
            style={{
              backgroundColor: 'var(--color-base-300)',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 0,
              color: 'var(--color-primary)',
              backgroundImage: referencesSection.image_url ? `url(${referencesSection.image_url})` : undefined,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
            }}
          >
            <FontAwesomeIcon
              icon={faScroll}
              style={{
                fontSize: '48px',
                opacity: 0.7,
              }}
            />
          </div>
        )}
        <ItemCard.Content>
          <ItemCard.Title>
            {referencesSection.title}
          </ItemCard.Title>
          <ItemCard.Description>
            {referencesSection.text_preview && (
              <div
                style={{
                  color: 'var(--color-base-content)',
                  fontSize: '14px',
                }}
              >
                {referencesSection.text_preview.length > 50
                  ? (
                    <div>
                      {referencesSection.text_preview.substring(0, 50) + '...'}{' '}
                    </div>
                  )
                  : referencesSection.text_preview}
              </div>
            )}
            <div className="ref-card-links">
              {referencesSection.references.map((ref: any, index: number) => (
                <Link
                  key={index}
                  className="link link-primary"
                  href={ref.path}
                >
                  {ref.title}
                </Link>
              ))}
            </div>
          </ItemCard.Description>
          <ItemCard.Actions>
            <div></div>
            <button
              className="btn btn-primary btn-sm"
              onClick={(e) => {
                e.stopPropagation();
              }}
            >
              Read more
            </button>
          </ItemCard.Actions>
        </ItemCard.Content>
      </ItemCard>
      <style>{`
        .ref-section-card {
          height: 275px;
        }
        .ref-card-image {
          width: 40%;
          height: 100%;
          flex-shrink: 0;
        }
        .ref-card-image-grid {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
        }
        .ref-card-links {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 4px;
          flex: 1;
          overflow: hidden;
        }
        @media (max-width: 640px) {
          .ref-section-card {
            height: auto;
          }
          .ref-card-image {
            width: 100%;
            height: 150px;
          }
          .ref-card-image-grid {
            grid-template-columns: repeat(4, 1fr);
          }
          .ref-card-links {
            grid-template-columns: repeat(2, 1fr);
            flex: none;
            max-height: none;
            overflow: visible;
          }
        }
      `}</style>
    </>
  )
}
